module.exports = __webpack_public_path__ + "img/nav-header-mobile-wedding@2x.53cac8d.webp";